/**
 * Centralised map of Web Intelligence website-analysis state names → their Sales Intelligence
 * website-analysis equivalents (the `WEBSITE_ANALYSIS_*` tabs of Company analysis).
 *
 * These SI pages reuse Web Intelligence components that link to their native WI states. While SI
 * is entered, those names are resolved to the SI equivalent before a URL or transition is built
 * (see {@link ./../utils/wiToSiStateResolver}), so the user stays inside SI.
 *
 * Add a new entry whenever a reused WI component links to a WI state that SI mirrors. WI states
 * without an SI equivalent must not be added here.
 */
import {
    WEBSITE_ANALYSIS_MARKETING_CHANNELS,
    WEBSITE_ANALYSIS_MARKETING_DISPLAY_OVERVIEW,
    WEBSITE_ANALYSIS_MARKETING_KEYWORDS,
    WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING,
    WEBSITE_ANALYSIS_MARKETING_SEARCH_ADS,
    WEBSITE_ANALYSIS_MARKETING_SEARCH_COMPETITORS,
    WEBSITE_ANALYSIS_MARKETING_SEARCH_OVERVIEW,
    WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW,
    WEBSITE_ANALYSIS_PERFORMANCE,
} from "./routes";

export const WI_TO_SI_WEBSITE_ANALYSIS_ROUTES: Readonly<Record<string, string>> = Object.freeze<Record<string, string>>(
    {
        digitalsuite_website_websiteperformance: WEBSITE_ANALYSIS_PERFORMANCE,
        digitalsuite_website_marketingchannels: WEBSITE_ANALYSIS_MARKETING_CHANNELS,
        digitalsuite_website_search_overview: WEBSITE_ANALYSIS_MARKETING_SEARCH_OVERVIEW,
        digitalsuite_website_search_ads: WEBSITE_ANALYSIS_MARKETING_SEARCH_ADS,
        digitalsuite_website_referrals_incomingtraffic: WEBSITE_ANALYSIS_MARKETING_REFERRAL_INCOMING,
        digitalsuite_website_display_overview: WEBSITE_ANALYSIS_MARKETING_DISPLAY_OVERVIEW,
        digitalsuite_website_social_overview: WEBSITE_ANALYSIS_MARKETING_SOCIAL_OVERVIEW,
        organicsearch_websites_v2_traffic_keywords: WEBSITE_ANALYSIS_MARKETING_KEYWORDS,
        "organicsearch_websites-competitorsKeywords": WEBSITE_ANALYSIS_MARKETING_SEARCH_COMPETITORS,
    },
);
